/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "./driver.component.less.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./driver.component";
var styles_DriverComponent = [i0.styles];
var RenderType_DriverComponent = i1.ɵcrt({ encapsulation: 0, styles: styles_DriverComponent, data: {} });
export { RenderType_DriverComponent as RenderType_DriverComponent };
export function View_DriverComponent_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "p", [], null, null, null, null, null)), (_l()(), i1.ɵted(-1, null, [" driver works!\n"]))], null, null); }
export function View_DriverComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 1, "app-driver", [], null, null, null, View_DriverComponent_0, RenderType_DriverComponent)), i1.ɵdid(1, 114688, null, 0, i2.DriverComponent, [], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var DriverComponentNgFactory = i1.ɵccf("app-driver", i2.DriverComponent, View_DriverComponent_Host_0, {}, {}, []);
export { DriverComponentNgFactory as DriverComponentNgFactory };
